import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }

import { computed, toRef } from 'vue'

    import type { MeetingStarterViewModel } from '@Evaluation/Estimations/Components/MeetingStarter'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingStarter',
  props: {
    viewModel: {}
  },
  emits: ["startMeeting", "openSurvey", "closeSurvey", "toggleAutoReveal", "toggleNamesRevealed", "showAccessLinks"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const surveyStarted = computed(() => vm.value.surveyStarted)
    const autoRevealEnabled = computed(() => vm.value.autoRevealEnabled)
    const namesRevealed = computed(() => vm.value.namesRevealed)

    // ---------------- actions ----------------

    function startMeeting()
    {
        emit('startMeeting')
    }

    function openSurvey()
    {
        emit('openSurvey')
    }

    function closeSurvey()
    {
        emit('closeSurvey')
    }

    function toggleAutoReveal()
    {
        emit('toggleAutoReveal')
        vm.value.autoRevealEnabled = !vm.value.autoRevealEnabled
    }

    function toggleNamesRevealed()
    {
        emit('toggleNamesRevealed')
        vm.value.namesRevealed = !vm.value.namesRevealed
    }

    function showAccessLinks()
    {
        emit('showAccessLinks')
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Set up your meeting​", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "lead" }, [
                  _createTextVNode(" Before you start your real-time meeting, let’s make sure everything is ready. "),
                  _createElementVNode("strong", null, "You can change any of these settings during the meeting.")
                ], -1 /* CACHED */)),
                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("tbody", null, [
                    (surveyStarted.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                          _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                            _createElementVNode("h5", null, "Survey is open"),
                            _createElementVNode("p", null, [
                              _createTextVNode("Your team can change their answers to "),
                              _createElementVNode("strong", null, "ANY question"),
                              _createTextVNode(" during the meeting. ")
                            ])
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", { class: "align-middle" }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-success btn-block text-nowrap",
                              onClick: closeSurvey
                            }, "Close survey")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (!surveyStarted.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                          _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                            _createElementVNode("h5", null, "Survey is closed"),
                            _createElementVNode("p", null, [
                              _createTextVNode("Your team will only be able to change their answers for the "),
                              _createElementVNode("strong", null, "question you’re on.")
                            ])
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", { class: "align-middle" }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-secondary btn-block text-nowrap",
                              onClick: openSurvey
                            }, "Open survey")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (autoRevealEnabled.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                          _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                            _createElementVNode("h5", null, "Auto reveal is ON"),
                            _createElementVNode("p", null, "When you move from question to question, your meeting participants WILL be able to see each others’ votes.​")
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", { class: "align-middle" }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-secondary btn-block text-nowrap",
                              onClick: toggleAutoReveal
                            }, "Turn off")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (!autoRevealEnabled.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                          _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                            _createElementVNode("h5", null, "Auto reveal is OFF"),
                            _createElementVNode("p", null, "When you move to the next question, we will automatically hide everyone’s votes. This can help reduce “follow my leader” bias and “group think.”")
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", { class: "align-middle" }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-secondary btn-block text-nowrap",
                              onClick: toggleAutoReveal
                            }, "Turn on")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (namesRevealed.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                          _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                            _createElementVNode("h5", null, "Anonymous mode is OFF"),
                            _createElementVNode("p", null, "When sharing votes, names WILL be displayed.​")
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", { class: "align-middle" }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-secondary btn-block text-nowrap",
                              onClick: toggleNamesRevealed
                            }, "Turn on")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (!namesRevealed.value)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                          _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                            _createElementVNode("h5", null, "Anonymous mode is ON"),
                            _createElementVNode("p", null, "When sharing votes, names WILL NOT be displayed.​")
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", { class: "align-middle" }, [
                            _createElementVNode("button", {
                              class: "btn btn-outline-secondary btn-block text-nowrap",
                              onClick: toggleNamesRevealed
                            }, "Turn off")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                        _createElementVNode("h5", null, "Access links"),
                        _createElementVNode("p", null, "These links will let your participants join the meeting with just one click. Why not (re)send them now?​")
                      ], -1 /* CACHED */)),
                      _createElementVNode("td", { class: "align-middle" }, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary btn-block text-nowrap",
                          onClick: showAccessLinks
                        }, "Access links")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: startMeeting,
                  type: "button",
                  class: "btn btn-primary"
                }, "Start the meeting"),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})